import React, {
  createContext, useState, useEffect, useMemo,
} from 'react';

export const NavigationContext = createContext();

// eslint-disable-next-line react/prop-types
export const NavigationProvider = ({ children }) => {
  const [prevPath, setPrevPath] = useState(null);

  useEffect(() => {
    // This only runs in the browser
    const currentPath = window.location.pathname;
    const lastPath = sessionStorage.getItem('currentPath');
    setPrevPath(lastPath);
    sessionStorage.setItem('currentPath', currentPath);
  }, []);

  const context = useMemo(() => ({
    prevPath,
  }), [prevPath]);

  return (
    <NavigationContext.Provider value={context}>
      {children}
    </NavigationContext.Provider>
  );
};
